import { Injectable } from '@angular/core';
import { Share } from '@capacitor/share';
import { secretKey } from 'src/environments/environment';
import CryptoJS from 'crypto-js';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { LoaderService } from './loader.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationStore } from '../stores/authentication.store';
@Injectable({
  providedIn: 'root',
})
export class MiscService {
  constructor(
    private loaderService: LoaderService,
    private translate: TranslateService,
    private auth: AuthenticationStore
  ) {}

  async saveImageLocally(fileUrl) {
    try {
      const timestamp = new Date().getTime();
      const filename = `${timestamp}.png`;
      var base64: any = await this.auth.getBase64(fileUrl);
      const srcRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
      const match = base64.data.match(srcRegex);
      if (match) {
        const srcAttribute = match[1];
        const savedFile = await Filesystem.writeFile({
          path: filename,
          data: srcAttribute,
          directory: Directory.Cache, // or choose an appropriate directory
          recursive: true,
        });
        return savedFile.uri;
      }
    } catch (error) {
      this.loaderService.dismissLoading();
      return null;
    }
  }

  async showShare(title, url, files, text) {
    this.loaderService.showLoading();
    var fileResp = await this.saveImageLocally(files[0]);
    this.loaderService.dismissLoading();
    var encryptedLink = await CryptoJS.AES.encrypt(
      encodeURIComponent(url),
      secretKey
    ).toString();
    encryptedLink = encryptedLink.replace(/\//g, 'Por21Ld');
    const shareUrl = `https://lojanteka.com/app/${encryptedLink}`;
    try {
      await Share.share({
        title: title,
        text: text,
        url: shareUrl,
        dialogTitle: 'Share',
        files: [fileResp ? fileResp : ''],
      });
    } catch (error) {
      this.loaderService.dismissLoading();
    }
  }
}
